import { Component, Prop, h, Host } from '@stencil/core';
import { angle_small_right } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-site-selector-item',
  styleUrl: 'pn-site-selector-item.scss',
})
export class PnSiteSelectorItem {
  /* Link URL */
  @Prop() url: string = '';

  /* Link title  */
  @Prop() heading: string = '';

  /* Link description */
  @Prop() description: string = '';

  /* Open link in new window */
  @Prop() newwindow: boolean = false;

  render() {
    return (
      <Host role="menuitem">
        {this.url ? (
          <a class="siteselector-item-link" href={this.url} target={this.newwindow ? '_blank' : 'self'} rel={this.newwindow ? 'nofollow noopener' : ''}>
            <span>
              {this.heading && <span class="siteselector-item-title">{this.heading}</span>}
              {this.description && <small class="siteselector-item-description">{this.description}</small>}
            </span>
            <pn-icon icon={angle_small_right} color="blue700" />
          </a>
        ) : (
          <div>
            {this.heading && <span class="siteselector-item-title">{this.heading}</span>}
            {this.description && <small class="siteselector-item-description">{this.description}</small>}
          </div>
        )}
      </Host>
    );
  }
}
